import React from "react";
import PropTypes from "prop-types";
import ContainerDimensions from "react-container-dimensions";
import { Row } from "react-flexbox-grid";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  LinearProgress,
  Typography
} from "@material-ui/core";
import Save from "@material-ui/icons/Save";

import CastsInFileTable from "./CastsInFileTable";

const styles = {
  yellowBackground: {
    display: "inline",
    backgroundColor: "hsl(40, 100%, 93%)",
    lineHeight: "175%"
  },
  redBackground: {
    display: "inline",
    backgroundColor: "hsl(359, 87%, 93%)",
    lineHeight: "175%"
  },
  orangeBackground: {
    display: "inline",
    backgroundColor: "#ffe1cc",
    lightHeight: "175%"
  }
};
const CastsInFileCard = props => (
  <Card>
    <CardHeader title="Casts in selected files" />
    <CardContent>
      {props.castsFetching && <LinearProgress style={{ marginBottom: 10 }} />}
      {/* {props.castsFetching &&
        <Row
          center="xs" style={{ marginBottom: "1rem" }}
          >
          <LinearProgress />
        </Row>} */}
      <Row center="xs">
        <ContainerDimensions>
          <CastsInFileTable {...props} />
        </ContainerDimensions>
      </Row>
      <Typography style={styles.yellowBackground}>
        Yellow warning: Form/instrument difference of 5-8 min or 5-10 metres
      </Typography>
      <br />
      <Typography style={styles.redBackground}>
        Red warning: Form/instrument difference of 8+ min or 10+ metres
      </Typography>
      <br />
      <Typography style={styles.orangeBackground}>
        Orange warning: the same form has been used to annotate more than one
        cast. Please either change the form or mark the extra cast(s) as
        miscast.
      </Typography>
    </CardContent>
    <CardActions>
      <Button
        variant="contained"
        color="primary"
        disabled={
          props.castsFetching ||
          props.savingFiles ||
          !!props.duplicateFormsInCastsBeingAnnotated.length
        }
        onClick={props.onAnnotateFileClick}
        style={{ marginLeft: "auto" }}
      >
        Save annotations
        <Save />
      </Button>
    </CardActions>
  </Card>
);

CastsInFileCard.propTypes = {
  castsFetching: PropTypes.bool,
  savingFiles: PropTypes.bool.isRequired,
  onAnnotateFileClick: PropTypes.func.isRequired,
  duplicateFormsInCastsBeingAnnotated: PropTypes.arrayOf(PropTypes.number)
    .isRequired
};

CastsInFileCard.defaultProps = {
  castsFetching: false
};

export default CastsInFileCard;
